import { createAsyncThunk } from '@reduxjs/toolkit';

import { NocApiClient } from '@nocowanie/noc-api';

import { SliceNameEnum } from '@app/enums';
import { environment } from '@app/environments/environment';

export const getUserProfile = createAsyncThunk<{ data: null }, { skipRequest?: boolean }>(
    `${SliceNameEnum.UserProfile}/fetch-data`,
    async ({ skipRequest = false } = {}, { rejectWithValue }) => {
        if (skipRequest) {
            return {
                data: null,
            };
        }

        try {
            const apiClient = new NocApiClient({ BASE: environment.NOC_API_END_POINT });
            const userProfileResponse = await apiClient.user.me();
            return { data: userProfileResponse };
        } catch (err) {
            if (err instanceof Error) {
                return rejectWithValue(err.message);
            } else {
                return rejectWithValue('Unknown error occurred');
            }
        }
    },
);
